"use client";

import { useEffect } from "react";

const BODY_FLAT_CORNERS_ATTR = "data-flat-corners";

type Props = {
  enabled?: boolean;
};

/**
 * Toggles the global flat-corner mode for the current route subtree and
 * restores the previous body state on cleanup so nested layouts can opt out.
 */
export default function BodyFlatCornersScope({
  enabled = true,
}: Props) {
  useEffect(() => {
    const previousValue = document.body.getAttribute(BODY_FLAT_CORNERS_ATTR);

    if (enabled) {
      document.body.setAttribute(BODY_FLAT_CORNERS_ATTR, "true");
    } else {
      document.body.removeAttribute(BODY_FLAT_CORNERS_ATTR);
    }

    return () => {
      if (previousValue == null) {
        document.body.removeAttribute(BODY_FLAT_CORNERS_ATTR);
        return;
      }

      document.body.setAttribute(BODY_FLAT_CORNERS_ATTR, previousValue);
    };
  }, [enabled]);

  return null;
}
